import React, { useState } from 'react';
import { registerCandidate } from '../../services/user/api';
import '../../styles/user/addCandidatePage.css';

const AddCandidatePage = () => {
  const [candidateData, setCandidateData] = useState({
    fullname: '',
    email: '',
    dateOfBirth: '',
    mobileNumber: '',
  });

  const [submissionStatus, setSubmissionStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [redirectTimeout, setRedirectTimeout] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  const handleCandidateChange = (e) => {
    const { name, value } = e.target;
    setCandidateData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateFields = () => {
    const errors = {};

    if (!candidateData.fullname?.trim()) {
      errors.fullname = 'Full name is required';
    } else if (!/^[A-Za-z ]+$/.test(candidateData.fullname)) {
      errors.fullname = 'Full name must contain only letters and spaces';
    } else if (candidateData.fullname.length > 40) {
      errors.fullname = 'Full name should not exceed 40 characters';
    }

    if (!candidateData.email?.trim()) {
      errors.email = 'Email is required';
} else if (!/^[a-zA-Z0-9._%+-]+@gmail\.com$/.test(candidateData.email)) {
  errors.email = 'Email format is invalid. Only @gmail.com is allowed';
}


    if (!candidateData.dateOfBirth) {
      errors.dateOfBirth = 'Date of birth is required';
    } else if (
      !/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/.test(
        `${candidateData.dateOfBirth.split('-')[2]}-${candidateData.dateOfBirth.split('-')[1]}-${candidateData.dateOfBirth.split('-')[0]}`
      )
    ) {
      errors.dateOfBirth = 'Date of birth must be in format dd-MM-yyyy';
    }

    if (!candidateData.mobileNumber?.trim()) {
      errors.mobileNumber = 'Mobile number is required';
    } else if (!/^\d{10}$/.test(candidateData.mobileNumber)) {
      errors.mobileNumber = 'Mobile number must be exactly 10 digits';
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateFields()) return;

    setLoading(true);
    try {
      const [year, month, day] = candidateData.dateOfBirth.split('-');
      const formattedData = {
        ...candidateData,
        dateOfBirth: `${day}-${month}-${year}`,
      };

      const response = await registerCandidate(formattedData);
      //console.log('Candidate Registered Response:', response);

      if (
        (response?.status === 200 || response?.status === 201) &&
        response?.data?.status === true
      ) {
        setSubmissionStatus('success');
      } else {
        setSubmissionStatus('error');
        setErrorMessage(response?.data?.message || 'Something went wrong.');
      }
    } catch (error) {
      console.error('Registration Error:', error);
      setSubmissionStatus('error');
      setErrorMessage(
        error?.response?.data?.message || 'Server error occurred. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setSubmissionStatus(null);
    setErrorMessage('');
    if (redirectTimeout) {
      clearTimeout(redirectTimeout);
      setRedirectTimeout(null);
    }

    // Optional: reset form
    setCandidateData({
      fullname: '',
      email: '',
      dateOfBirth: '',
      mobileNumber: '',
    });
  };

  return (
    <>
      <p className="profile-header">Create Login Credentials for a Candidate</p>

      <div className="add-candidate-container">
        {submissionStatus === 'success' && (
          <div className="modal-overlay">
            <div className="add-success-modal">
              <h3>✅ Candidate registered successfully!</h3>
              <button className="ok-btn" onClick={handleCloseModal}>
                OK
              </button>
            </div>
          </div>
        )}

        {submissionStatus === 'error' && (
          <div className="modal-overlay">
            <div className="add-fail-modal">
              <h3>❌ Registration Failed</h3>
              <p>{errorMessage}</p>
              <button className="ok-btn" onClick={handleCloseModal}>
                OK
              </button>
            </div>
          </div>
        )}

        <div className="user-form-card">
          <div className="form-groups">
            <label>Candidate Name *</label>
            <input
              type="text"
              name="fullname"
              value={candidateData.fullname}
              onChange={handleCandidateChange}
              placeholder="Enter Candidate Name"
            />
            {fieldErrors.fullname && <p className="field-error">{fieldErrors.fullname}</p>}
          </div>

          <div className="form-groups">
            <label>Enter Candidate Email-Id *</label>
            <input
              type="email"
              name="email"
              value={candidateData.email}
              onChange={handleCandidateChange}
              placeholder="Email Address"
            />
            {fieldErrors.email && <p className="field-error">{fieldErrors.email}</p>}
          </div>

          <div className="form-groups">
            <label>Date of birth *</label>
            <input
              type="date"
              name="dateOfBirth"
              value={candidateData.dateOfBirth}
              onChange={handleCandidateChange}
            />
            {fieldErrors.dateOfBirth && <p className="field-error">{fieldErrors.dateOfBirth}</p>}
          </div>

          <div className="form-groups">
            <label>Mobile Number *</label>
            <input
              type="text"
              name="mobileNumber"
              value={candidateData.mobileNumber}
              onChange={handleCandidateChange}
              placeholder="Mobile number"
            />
            {fieldErrors.mobileNumber && <p className="field-error">{fieldErrors.mobileNumber}</p>}
          </div>

          <button className="submit-btn" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Registering...' : 'Register Candidate'}
          </button>
        </div>
      </div>
    </>
  );
};

export default AddCandidatePage;
